import styled from 'styled-components';
import { Flex } from '#atoms';

export const Wrapper = styled.section``;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.gray15};
  white-space: pre-wrap;
  margin-bottom: 56px;
`;

export const SubTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.gray15};
`;

export const Description = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.gray100};
  margin-top: 8px;
  margin-bottom: 20px;
`;

export const CheckBoxWrapper = styled(Flex)`
  margin: 20px 0px;
`;
